import { Outlet } from 'react-router-dom';
import { ReactNode } from 'react';

import { useAppSelector } from '../redux/hooks';
import { ErrorPageNoSelectedOrganization } from '../components/ErrorPageNoSelectedOrganization/ErrorPageNoSelectedOrganization';

export const RequireSelectedOrganization = ({ children }: { children?: ReactNode }) => {
  const selectedPartnerNumberOrganization = useAppSelector(state => state.auth.user?.selectedPartnerNumberOrganization);

  if (!selectedPartnerNumberOrganization) {
    return <ErrorPageNoSelectedOrganization />;
  }

  return children ?? <Outlet />;
};
